const MIN_REJECTION_NOTES_LENGTH = 10;

export function getRejectionNotesError(notes: string): string | null {
  const length = notes.trim().length;

  if (length === 0) {
    return 'Rejection notes are required';
  }

  if (length < MIN_REJECTION_NOTES_LENGTH) {
    const remaining = MIN_REJECTION_NOTES_LENGTH - length;
    return `Add ${remaining} more character${remaining === 1 ? '' : 's'}`;
  }

  return null;
}
